"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../../../container/ServiceIdentifiers");
const TIdentifierNamesGeneratorFactory_1 = require("../../../../types/container/generators/TIdentifierNamesGeneratorFactory");
const IOptions_1 = require("../../../../interfaces/options/IOptions");
const AbstractObfuscatingReplacer_1 = require("../AbstractObfuscatingReplacer");
const NodeFactory_1 = require("../../../../node/NodeFactory");
let BaseIdentifierObfuscatingReplacer = class BaseIdentifierObfuscatingReplacer extends AbstractObfuscatingReplacer_1.AbstractObfuscatingReplacer {
    constructor(identifierNamesGeneratorFactory, options) {
        super(options);
        this.blockScopesMap = new Map();
        this.identifierNamesGenerator = identifierNamesGeneratorFactory(options);
    }
    replace(identifierNode, lexicalScopeNode) {
        let identifierName = identifierNode.name;
        if (this.blockScopesMap.has(lexicalScopeNode)) {
            const namesMap = this.blockScopesMap.get(lexicalScopeNode);
            if (namesMap.has(identifierName)) {
                identifierName = namesMap.get(identifierName);
            }
        }
        return NodeFactory_1.NodeFactory.identifierNode(identifierName);
    }
    storeGlobalName(identifierNode, lexicalScopeNode) {
        const identifierName = identifierNode.name;
        if (this.isReservedName(identifierName)) {
            return;
        }
        const newIdentifierName = this.identifierNamesGenerator.generateWithPrefix();
        if (!this.blockScopesMap.has(lexicalScopeNode)) {
            this.blockScopesMap.set(lexicalScopeNode, new Map());
        }
        const namesMap = this.blockScopesMap.get(lexicalScopeNode);
        namesMap.set(identifierName, newIdentifierName);
    }
    storeLocalName(identifierNode, lexicalScopeNode) {
        const identifierName = identifierNode.name;
        if (this.isReservedName(identifierName)) {
            return;
        }
        const newIdentifierName = this.identifierNamesGenerator.generate();
        if (!this.blockScopesMap.has(lexicalScopeNode)) {
            this.blockScopesMap.set(lexicalScopeNode, new Map());
        }
        const namesMap = this.blockScopesMap.get(lexicalScopeNode);
        namesMap.set(identifierName, newIdentifierName);
    }
    preserveName(name) {
        this.identifierNamesGenerator.preserveName(name);
    }
    isReservedName(name) {
        if (!this.options.reservedNames.length) {
            return false;
        }
        return this.options.reservedNames
            .some((reservedName) => {
            return new RegExp(reservedName, 'g').exec(name) !== null;
        });
    }
};
BaseIdentifierObfuscatingReplacer = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IIdentifierNamesGenerator)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory !== "undefined" && TIdentifierNamesGeneratorFactory_1.TIdentifierNamesGeneratorFactory) === "function" ? _a : Object, typeof (_b = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _b : Object])
], BaseIdentifierObfuscatingReplacer);
exports.BaseIdentifierObfuscatingReplacer = BaseIdentifierObfuscatingReplacer;
